import React from 'react'
import { Text, Spacing, Box, GradientWrapper } from '../../../components/ui'

export const SummaryCard = ({ title, value }) => {
  return (
    <Box as={GradientWrapper} size="l" gradient="gradient1">
      <Spacing size="m">
        <Text h6 color="white">
          {title}
        </Text>
        <Text h2 color="white">
          {value}
        </Text>
      </Spacing>
    </Box>
  )
}
